<template>
  <component-wrapper v-if="!isAppView">
    <footer class="fixperience-footer-fi">
      <div class="fixperience-footer-fi__legals">
        <grid-container-fi>
          <div
            v-if="footerData?.legalLinks?.elements"
            class="fi-col-span-full"
          >
            <ul class="fixperience-footer-fi__legals--links">
              <li>
                {{ footerData.legalLinks.title }}
              </li>
              <template v-for="item in footerData.legalLinks.elements">
                <li
                  v-if="item?.link?.url && getLinkText(item)"
                  :key="item.id"
                >
                  <a
                    :href="item.link.url"
                    class="fixperience-footer-fi--link"
                  >
                    {{ getLinkText(item) }}
                  </a>
                </li>
              </template>
            </ul>
          </div>
        </grid-container-fi>
      </div>
    </footer>
  </component-wrapper>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import ComponentWrapper from '@/components/component-wrapper/ComponentWrapper.vue';
import GridContainerFi from '@/components/grid-fi/GridContainerFi.vue';
import type { LinkFieldValue } from '@/sitecoreFieldTypes';
import { useLayoutStore } from '@/store/pinia/layout';
import lowerCaseKeys from '@/utils/lowerCaseKeys';

const layoutStore = useLayoutStore();

const props = withDefaults(
  defineProps<{
    customData?: {
      footer?: FooterData;
    };
  }>(),
  {
    customData: undefined,
  },
);

interface SitecoreLinkElement {
  id: string;
  link?: LinkFieldValue;
  displayName?: string;
  title: string;
}

interface SitecoreLinks {
  elements?: Array<SitecoreLinkElement>;
  title?: string;
}

interface FooterData {
  legalLinks?: SitecoreLinks;
}

const footerData = computed<FooterData | undefined>(() => {
  if (IS_SSR && props.customData?.footer) {
    // The same normalisation setLayoutData applies to the client's copy, so both sides read the
    // same keys - the raw prop still carries Sitecore's casing further down (Language.Name).
    return lowerCaseKeys(props.customData.footer, true);
  } else {
    return layoutStore.footerData;
  }
});

const getLinkText = (item: SitecoreLinkElement): string | undefined =>
  item.link?.text || item.displayName;
</script>

<style scoped src="./fixperience-footer-fi" />
